'use strict';

const _ = require('lodash');
const $ = require('jquery');

const {default: fecha} = require('fecha');
const numeral = require('numeral');
const TS = require("@zerolight/zlthunder-time-utils");

const {CSSList}  = require('./css-list');

function noop() {
}

function identity(v) {
	return v;
}

const OPT = {__n: 'OPT'};
const REQ = {__n: 'REQ'};
const CB = {__n: 'CB'};
const ND = {__n: 'ND'};

function isREQ(a) {
	return a === REQ;
}

function getDefaultValue(a, value) {
	if (arguments.length === 1) {
		value = ND;
	}

	if (a === REQ) {
		if (value === ND) {
			throw new Error('Required argument not provided');
		}
		return value;
	}

	if (a === CB) {
		if (_.isFunction(value)) {
			return value;
		}
		return _.noop;
	} else if (a === OPT) {
		if (value === ND) {
			return undefined;
		}
		return value;
	} else if (_.isFunction(a)) {
		if (value !== ND && a(value)) {
			return value;
		} else {
			return undefined;
		}
	}

	if (value === ND) {
		return a;
	} else {
		return value;
	}
}

function bestMatch(a, rest) {
	let m = -1, i, l;
	for (i = 0, l = rest.length; i < l; i++) {
		let r = rest[i];
		if (r === REQ && m === -1) {
			return i;
		}
		if (r === CB) {
			if (_.isFunction(a)) {
				return i;
			}
			continue;
		}
		if (_.isFunction(r)) {
			if (r(a)) {
				// If function returns true - that's it, best match.
				return i;
			} else if (m === -1) {
				// Works like OPT then.
				m = i;
			}
		}
		if (m === -1) {
			// OPT
			m = i;
		}
	}
	return m;
}

/**
 * Slightly easier way to rearrange arguments for method.
 * Usage examples:
 *
 *   * `rearg2(f, rearg2.REQ, rearg2.OPT, rearg2.CB)` - First argument is required,
 *      the second argument can be omitted,
 *      the last argument is callback and will be replaced with `_.noop` if not given.
 *   * `rearg2(f, _.isPlainObject, rearg2.CB)` - first argument expected to be plain object.
 *      If it's not - it will be omitted. The second argument - is callback.
 *   * `rearg2(f, 5)` - 5 will be passed to `f` as first argument if it's not given.
 *
 * @param {function} f - function to wrap.
 * @param {...*} args - arguments definition.
 * @returns {function}
 */
function rearg(f, args) {
	let reargs = _.toArray(arguments);
	f = reargs.shift();
	let needed = _.filter(reargs, isREQ).length;
	let callbackNeeded = _.last(reargs) === CB;

	if (reargs.length === 0) {
		throw 'Invalid arguments';
	}

	return function reargWrapper() {
		let args = _.toArray(arguments);
		let j, l, a, n = needed,
			p, rp, rest = reargs.slice(), fargs = [], cb;

		if (callbackNeeded && _.isFunction(_.last(args))) {
			cb = _.last(args);
			args = _.initial(args);
			rest = _.initial(rest);
		}

		while (rest.length) {
			l = args.length;
			if (l < n) {
				throw new Error("Not enough arguments");
			} else if (!l) {
				// No more arguments given, fill with defaults and break
				for (j = 0, p = rest.length; j < p; j++) {
					fargs.push(getDefaultValue(rest[j]));
				}
				break;
			}

			if (l > n) {
				// We have more then needed arguments, let's consume one and do a bestMatch.
				a = args.shift();
				p = bestMatch(a, rest);
				if (p === -1) {
					throw new Error('Arguments don\'t match');
				}
				for (j = 0; j < p; j++) {
					fargs.push(getDefaultValue(rest[j]));
				}
				rp = rest[p];
				fargs.push(getDefaultValue(rp, a));
				if (rp === REQ) {
					n -= 1;
				}
				rest = rest.slice(p + 1);
			} else {
				// Remaining arguments are not enough, so we don't do bestMatch
				rp = rest.shift();
				if (rp === REQ) {
					n -= 1;
					fargs.push(args.shift());
				} else {
					fargs.push(getDefaultValue(rp));
				}
			}
		}
		if (cb) {
			fargs.push(cb);
		}
		return f.apply(this, fargs);
	};
}

rearg.REQ = REQ;
rearg.OPT = OPT;
rearg.CB = CB;

function isContainer($container) {
	return $container instanceof $ || _.isElement($container) || _.isString($container);
}

function cssClasses() {
	let c = new CSSList();
	for (let a of arguments) {
		c.add(a);
	}
	return c.css;
}

let DATE_FORMAT = 'YYYY-MM-DD';
let DATE_TIME_FORMAT = 'YYYY-MM-DD h:mm a';

function formatDate(value, format) {
	value = TS.validate(value);
	if (!value) {
		return '';
	}

	if (format) {
		return fecha.format(value, format);
	}

	let hours = value.getHours();
	let minutes = value.getMinutes();
	if (hours || minutes) {
		format = DATE_TIME_FORMAT;
	} else {
		format = DATE_FORMAT;
	}
	return fecha.format(value, format);
}

function formatNumber(value, format) {
	if (!value) {
		return 0;
	}
	let n = Number(value);
	if (isNaN(n)) {
		return value;
	}
	return numeral(n).format(format || numeral.defaultFormat);
}

function formatMinutes(value) {
	if (value) {
		let m = numeral(Math.floor(value / 60)).format(numeral.defaultFormat);
		let sec = Math.round(value % 60);
		if (sec === 60) {
			m += 1;
			sec = 0;
		}
		sec = _.padStart(sec, 2, '0');
		return `${m}:${sec}`;
	}
	return '';
}

function pretty(value) {
	return _.words(value).map(_.capitalize).join(' ');
}

function bindHandler(context, handler) {
	return function () {
		return handler.call(context, this, ... arguments);
	}
}

function bindHandlers(context, ... names) {
	for (let name of names) {
		let handler = context[name];
		if (!_.isFunction(handler)) {
			throw new TypeError(`${name} should be a function`);
		}
		context[name] = bindHandler(context, handler);
	}
}

function bindCallback(method, context, ... bargs) {
	return function wrapper(... args) {
		let callback;
		let l = args.length;
		if (l && _.isFunction(args[l - 1])) {
			callback = args[l - 1];
			// args = args.slice(0, -1);
		}
		// If it returns promise...
		let returns = method.call(context, ...bargs, ...args);
		if (returns instanceof Promise) {
			if (callback) {
				// If callback is given - handle it and return nothing
				returns
					.then(
						function (result) {
							callback(null, result);
						},
						function (reason) {
							callback(reason);
						}
					)
					.catch(function (err) {
						console.error(err);
					});
				return;
			}
		}
		return returns;
	}
}

function bindCallbackAll(obj, ... methods) {
	for (let key of methods) {
		let method = obj[key];
		if (_.isFunction(method)) {
			obj[key] = bindCallback(method, obj);
		}
	}
}

function thenCallback(promise, callback) {
	if (callback) {
		promise
			.then(
				function (response) {
					callback(null, response);
				},
				function (err) {
					callback(err);
				}
			)
			.catch(function (err) {
				console.error(err);
				throw err;
			});
	} else {
		return promise;
	}
}

const DOES_IT_LOOK_LIKE_REGEXP = /^\/(.+)\/([im]+)?$/;
function testString(test, string) {
	let m;
	if (test instanceof RegExp) {
		return test.test(string);
	}
	if ((m = DOES_IT_LOOK_LIKE_REGEXP.test(test))) {
		test = new RegExp(m[1], m[2]);
		return test.test(string);
	}
	return test === string;
}

module.exports = {
	noop, identity,
	rearg, cssClasses, isContainer, formatDate, formatNumber, formatMinutes, pretty,
	bindHandler, bindHandlers, bindCallback, bindCallbackAll, thenCallback, testString
};